import { PlusSquareIcon } from '@phosphor-icons/react';
import { XIcon } from 'lucide-react';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { AddCategoryDialog, CategoriesTable, PromptsTable } from '../components';
import { SystemPromptCategoryResponse } from '../types';

export const SystemPromptsPage: FC = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] =
    useState<SystemPromptCategoryResponse | null>(null);
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  return (
    <div>
      <PageHeader
        title="System Prompts"
        actions={
          selectedCategory
            ? [
                <Button
                  key="create-prompt"
                  onClick={() =>
                    navigate(Routes.SystemPromptsNewPrompt, {
                      state: {
                        categoryId: selectedCategory.id,
                        categoryName: selectedCategory.name,
                        content: '',
                      },
                    })
                  }
                >
                  <PlusSquareIcon />
                  Create System Prompt
                </Button>,
              ]
            : [
                <Button key="add-category" onClick={() => setAddDialogOpen(true)}>
                  <PlusSquareIcon />
                  Add New Category
                </Button>,
              ]
        }
      />

      {selectedCategory ? (
        <>
          <div className="flex items-center gap-3 mb-5 px-3 py-2 bg-zinc-800 rounded-lg w-fit">
            <span className="text-sm text-zinc-400">Category:</span>
            <span className="text-sm font-medium text-zinc-100">
              {selectedCategory.name}
            </span>
            <Button
              variant="ghost"
              size="sm"
              className="h-5 w-5 p-0 hover:bg-zinc-700"
              onClick={() => setSelectedCategory(null)}
            >
              <XIcon size={14} />
            </Button>
          </div>
          <PromptsTable categoryId={selectedCategory.id} categoryName={selectedCategory.name} />
        </>
      ) : (
        <CategoriesTable onSelect={setSelectedCategory} />
      )}

      <AddCategoryDialog
        isOpen={addDialogOpen}
        onOpenChange={setAddDialogOpen}
      />
    </div>
  );
};
